import { ComponentGroup } from '../types.js'

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:{{strokeColor}};}
    .st7{fill:none;stroke:{{strokeColor}};stroke-width:1.5;stroke-miterlimit:10;}
    .st9{fill:none;stroke:{{strokeColor}};stroke-miterlimit:10;}
  </style>
  <g>
    <polygon class="st7" points="15.3,10.5 7.3,13.6 7.3,22.8 15,26.1 22.9,22.8 22.9,14.1"/>
    <polygon class="st0" points="22.2,22.5 14.8,26.1 14.5,16.6 22.2,14.1"/>
    <line class="st9" x1="15.1" y1="4.2" x2="15.1" y2="10.4"/>
    <polyline class="st9" points="13.3,5.6 15.1,3.8 17,5.6"/>
    <line class="st9" x1="27.9" y1="25.2" x2="22.4" y2="22.4"/>
    <polyline class="st9" points="27.5,22.9 28.3,25.4 25.8,26.2"/>
    <line class="st9" x1="2.1" y1="25.2" x2="7.6" y2="22.4"/>
    <polyline class="st9" points="2.5,22.9 1.7,25.4 4.2,26.2"/>
    <line class="st9" x1="7.9" y1="14.1" x2="15.5" y2="17.4"/>
  </g>
</svg>
`

export const threed: ComponentGroup = {
  name: '3D',
  description: 'a group of various 3D base components',
  icon,
  templates: []
}
